module.exports = __webpack_public_path__ + "icofont.e9c9d055c9df0aa13ddb.svg";


//////////////////
// WEBPACK FOOTER
// D:/Wilson/I4 Soluciones/Proyecto Web QA/proyecto-web-clientes-atica-agosto/src/assets/icon/icofont/fonts/icofont.svg?v=1.0.0-beta
// module id = ../../../../../src/assets/icon/icofont/fonts/icofont.svg?v=1.0.0-beta
// module chunks = styles